export default __webpack_public_path__ + "static/media/5.8c3f8ab5.png";